import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Avatar from '#components/a/Avatar'
import StyledText from '#components/a/StyledText'
import UserInfoHOC from '#components/HOC/UserInfoHOC'

function MessageBenachrichtigung({userInfo, message, link, onNotificationClick}) {
  const redirectAndMarkAsRead = () => {
    if (link !== '') {
      window.open(link, '_blank', 'noopener,noreferrer,')
    }
    onNotificationClick()
  }

  const text = i18n.t('notification_text_from_ausbilder', [message, `${userInfo.firstname} ${userInfo.lastname}`])

  return (
    <div
      role="button"
      tabIndex={0}
      className="notification urgent"
      onClick={() => redirectAndMarkAsRead()}
      onKeyPress={() => redirectAndMarkAsRead()}
    >
      <Avatar profileImage={userInfo.profileImage} />
      <StyledText text={text} modifier="notification message" />
    </div>
  )
}

MessageBenachrichtigung.propTypes = {
  userInfo: PropTypes.shape({
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    profileImage: PropTypes.string,
  }).isRequired,
  message: PropTypes.string,
  link: PropTypes.string,
  onNotificationClick: PropTypes.func.isRequired,
}

export default UserInfoHOC(MessageBenachrichtigung, ['senderId'])
